import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/resource-categories")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Categories")),
  head: () => ({
    meta: seo({ title: "Resource Categories" }),
  }),
});
